var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMondayDotCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF3D57;}\r\n\t.st1{fill:#FFCB00;}\r\n\t.st2{fill:#00D647;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.918418 0 0 .918418 3.800969 2.447472)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.051626 0 0 2.051626 -18.029941 -31.126435)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.2,49.7c-2.7,0-4.9-2.2-4.9-4.9c0-0.9,0.3-1.8,0.7-2.6l8.8-14c1.4-2.3,4.4-3,6.7-1.5 c2.3,1.4,3,4.4,1.5,6.7l-8.8,14C29.4,48.8,27.9,49.7,26.2,49.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.3,49.7c-2.7,0-4.9-2.2-4.9-4.9c0-0.9,0.3-1.8,0.7-2.6l8.8-14c1.3-2.3,4.3-3.1,6.6-1.8 c2.3,1.3,3.1,4.3,1.8,6.6c-0.1,0.1-0.1,0.2-0.2,0.3l-8.7,14C44.5,48.8,42.9,49.7,41.3,49.7L41.3,49.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 56.3,
    cy: 44.9,
    rx: 4.9,
    ry: 4.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMondayDotCom);
export default __webpack_public_path__ + "static/media/MondayDotCom.1d24d4af3af75baccde18fa161effd40.svg";
export { ForwardRef as ReactComponent };